import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    exportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    gameList: [],
    company: [],
    staffUserList: [],
    contestList: [],
    contestTotalCounts: 0

}

export const callTypes = {
    list: "list",
    action: "action"
};

export const AddContestAssignSlice = createSlice({
    name: "addContestsAssign",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        assignedContestList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
            state.contestList = [];
            // state.totalCount = 0;
            state.exportData = [];
        },
        gameList: (state, action) => {
            const { totalCount, entities } = action.payload;
            // console.log(entities)
            state.listLoading = false;
            state.error = null;
            state.gameList = entities;
            // state.totalCount = totalCount;
        },
        company: (state, action) => {
            const { totalCount, entities } = action.payload;
            // console.log(entities)
            state.listLoading = false;
            state.error = null;
            state.company = entities;
            // state.totalCount = totalCount;
        },
        staffUsersFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.staffUserList = entities;
            // state.totalCount = totalCount;
        },

        contestListList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.contestList = entities;
            state.contestTotalCounts = totalCount;
        },

    }
})